import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { FunctionComponent, useEffect, useState } from "react";
import { Faq, fetchFaqs, filterAndSort } from "../faqSlice";
import { FaqCard } from "./FaqCard";
import { FaqListTools } from "./FaqListTools";
import { useAuth } from "react-oidc-context";

import styled from 'styled-components'
import { Box } from "../../shared/components/widgets/Box";
import { Loading } from "../../shared/components/Loading";

export const Wrapper = styled.div`
  display: grid;

  padding-top: 3rem;
  width: 100%;
  max-width: 1640px;
`
/**
 * This is a (potentially filtered) list of faqs
 * @returns a display of ordered EventCard items, and (for editors) tools for adding, reordering and deleting EventCard items
 */
export const FaqList = () => {
  const dispatch = useAppDispatch();
  const faqstate = useAppSelector(state => state.faqstate);
  const auth = useAuth();

  const [faqs, setFaqs] = useState([] as Faq[])
  const [cats, setCats] = useState([] as string[])

    // make sure that we have men
    useEffect(() => {
      if (faqstate.status === 'idle' || !faqstate.faqs || faqstate.faqs.length === 0) {
        dispatch(fetchFaqs());
      }
    }, [dispatch])
    
    // set up the filtered list
    useEffect( () => {
      // in case faqs have not been initialised  
  
      setFaqs(filterAndSort(faqstate.faqs,'general'));
      setCats(faqstate.generalCats);
  
      // tracking whats going on
  
      console.log(faqs)
      console.log(!cats || cats.length === 0)
  
    }, [faqstate.faqs])
  
  
  return (faqstate.status === 'idle' || faqstate.status === 'pending') ? (
    <Loading centre />
  ) : (
    <Wrapper>
      <div className='lr-padded-container center-text'>
        <h1 style={{marginBottom: '25px'}}>frequently asked questions</h1>
        <hr style={{maxWidth: '200px', marginInline: 'auto'}}/>
      </div>

      <div className='lr-padded-container center-text'>
        <p>If you don't find your question, below please don't hesitate to contact us. </p>
      </div>

      { auth.isAuthenticated && ( <FaqListTools /> )}

      {            
        faqs && ((!cats || cats.length < 2) ? <SimpleFaqList faqs={faqs} /> : <CategorisedFaqList faqs={faqs} cats={cats}/>)  
      }
      
    </Wrapper>
  )

}
type FaqListParams = {
  faqs: Faq[]
  cats?: string[]
}
const SimpleFaqList: FunctionComponent<FaqListParams> = ( props ): JSX.Element => {
  console.log(props.faqs)
  return <div className="lr-padded-container">{props.faqs.map((faq) => <FaqCard key={faq.id} faq={faq} />)}</div>;
}

const CategorisedFaqList: FunctionComponent<FaqListParams> = ( props ): JSX.Element => {

  const compareCats = (a: Faq, b: Faq) => {
    if (a.category.toUpperCase() < b.category.toUpperCase()) {
      return -1;
    } else if (a.category.toUpperCase() > b.category.toUpperCase()) {
      return 1;
    } else {
      return 0;
    }
  }

  const sorted: Faq[] = props.faqs.sort(compareCats);

    // group faqs into category lists.
  let currentCat: string = 'notACat';
  
  const components: JSX.Element[] = [];
  sorted.forEach((faq) => {
    if (currentCat==='notACat' || faq.category === undefined) {
      //components.push(<Box>General</Box>);
    } else if (currentCat==='notACat' || faq.category !== currentCat) {
      components.push(<Box>{faq.category}</Box>);
    }
    components.push(<FaqCard key={faq.id} faq={faq} />);
  })

  return <div className="lr-padded-container">{components}</div>;
  
}